import {
  actionCreator,
  createRequestTypes,
  createApiActions,
} from 'Redux/actions'

export const LOAD_BUILDING_ALERT = 'LOAD_BUILDING_ALERT'
export const loadBuildingAlert = () => actionCreator(LOAD_BUILDING_ALERT)

export const LOAD_BUILDING_ALERT_FETCH = createRequestTypes('LOAD_BUILDING_ALERT_FETCH')
export const loadBuildingAlertFetchActions = createApiActions(LOAD_BUILDING_ALERT_FETCH)

export const CREATE_BUILDING_ALERT = 'CREATE_BUILDING_ALERT'
export const createBuildingAlert = payload =>
  actionCreator(CREATE_BUILDING_ALERT, { payload })

export const CREATE_BUILDING_ALERT_FETCH = createRequestTypes('CREATE_BUILEING_ALERT_FETCH')
export const createBuildingAlertActions = createApiActions(CREATE_BUILDING_ALERT_FETCH)

export const UPDATE_BUILDING_ALERT = createRequestTypes('UPDATE_BUILDING_ALERT')
export const updateBuildingAlertActions = createApiActions(UPDATE_BUILDING_ALERT)

export const DELETE_BUILDING_ALERT = createRequestTypes('DELETE_BUILDING_ALERT')
export const deleteBuildingAlertActions = createApiActions(DELETE_BUILDING_ALERT)

export const LOAD_BUILDINGS = 'LOAD_BUILDINGS'
export const loadBuildings = ({ buildingIds, alertId }) =>
  actionCreator(LOAD_BUILDINGS, { buildingIds, alertId })

export const LOAD_BUILDINGS_FETCH = createRequestTypes('LOAD_BUILDINGS_FETCH')
export const LOAD_BUILDINGS_ACTIONS = createApiActions(LOAD_BUILDINGS_FETCH)

export const TURN_OFF_ALL_BUILDING_ALERTS = 'TURN_OFF_ALL_BUILDING_ALERTS'
export const turnOffAllBuildingAlerts = () =>
  actionCreator(TURN_OFF_ALL_BUILDING_ALERTS)

export const ADD_ALGOLIA_BUILDING = 'ADD_ALGOLIA_BUILDING'
export const addAlgoliaBuilding = ({ alertId, building }) =>
  actionCreator(ADD_ALGOLIA_BUILDING, { alertId, building })

export const REMOVE_ALOGLIA_BUILDING = 'REMOVE_ALOGLIA_BUILDING'
export const removeAlgoliaBuilding = ({ alertId, buildingId }) =>
  actionCreator(REMOVE_ALOGLIA_BUILDING, { alertId, buildingId })

export const RESET_BUILDING_ALERT = 'RESET_BUILDING_ALERT'
export const resetBuildingAlert = () => actionCreator(RESET_BUILDING_ALERT)

